/*
 * File: StandAloneNav.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe on 06/25/2018
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays a back button FAB in the bottom left of the screen
 * if the page is being run from a home page shortcut (it is running "standalone")
 */
import React from "react";
import Fab from "@material-ui/core/Fab";
import BackBtn from "@material-ui/icons/ChevronLeft";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  backBtn: {
    zIndex: 9999999,
    position: "fixed",
    bottom: params =>
      params.isApptsPage ? theme.spacing(6) : theme.spacing(2),
    left: theme.spacing(1.5),
    opacity: 0.6,
    background: theme.palette.common.icons,
    color: theme.palette.common.white
  }
}));

const StandAloneNav = () => {
  let isStandalone;
  //iOS provides window.navigator.standalone
  if ("standalone" in window.navigator) {
    isStandalone = window.navigator.standalone;
  } else {
    //Chrome has to make a media query
    isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  }

  const goBack = () => {
    window.history.back();
  };

  const isApptsPage = window.location.pathname.includes("appointments");
  const classes = useStyles({ isApptsPage: isApptsPage });

  if (!isStandalone) return null;
  return (
    <Fab size="small" className={classes.backBtn}>
      <BackBtn onClick={goBack} />
    </Fab>
  );
};

export default StandAloneNav;
